// import { mockApi } from '../../../utils/utils';


// const REQUEST_DELAY_MS = 2000;

export const getEmployees = async () =>
    [
        {
            "_id": "5ef9e1f3fa9041662b3abb43",
            "userId": "5ef9e1f3fa9041662b3abb42",
            "empId": "345435",
            "designation": "SE",
            "client": "dfsdf",
            "reportTo": "sdfsdf",
            "skills": "java11, js",
            "resumeUrl": null,
            "user": {
                "_id": "5ef9e1f3fa9041662b3abb42",
                "firstName": "ssssddddd",
                "middleName": "rudra",
                "lastName": "pal",
                "age": "90",
                "gender": "MALE",
                "profilePic": "NA",
                "email": "ravikumarg45678@gmail.com",
                "phoneNumber": null,
                "password": "$2a$10$Sj9AHSUfc5Oq4/cXcSq1Ru9NwxZKbkSl.JVvL83Ok4mmgp0cwfGTu",
                "role": [],
                "type": "employee",
                "resumeUrl": null,
                "resetToken": null,
                "roles": []
            }
        },
        {
            "_id": "5efd964301638020b8e7a4b4",
            "userId": "5efd964301638020b8e7a4b3",
            "empId": "1234",
            "designation": "SSE",
            "client": null,
            "reportTo": null,
            "skills": null,
            "resumeUrl": null,
            "user": {
                "_id": "5efd964301638020b8e7a4b3",
                "firstName": "Channabasavaraj",
                "middleName": null,
                "lastName": "Gorebal",
                "age": null,
                "gender": null,
                "profilePic": null,
                "email": "abhisheksh@maveric-systems.com",
                "phoneNumber": "08970401917",
                "password": "$2a$10$F.N8xu3v9Ss2T.A0D2sA.e3rM1Up7ArzdfCilxRK5haHt6rhEzYGe",
                "role": [],
                "type": "employee",
                "resumeUrl": null,
                "resetToken": null,
                "roles": []
            }
        },
        {
            "_id": "5efee598f83bae2a643ad1f4",
            "userId": "5efee598f83bae2a643ad1f3",
            "empId": "ravikumarg@maveric-systems.com",
            "designation": "SSE",
            "client": null,
            "reportTo": null,
            "skills": null,
            "resumeUrl": null,
            "user": {
                "_id": "5efee598f83bae2a643ad1f3",
                "firstName": "Channabasavaraj",
                "middleName": null,
                "lastName": "Gorebal",
                "age": null,
                "gender": null,
                "profilePic": null,
                "email": "ravikumarg@maveric-systems.com",
                "phoneNumber": "08970401917",
                "password": "$2a$10$jdFjxB5C0Jr0nQWyODR7e.sa1vR4ICzBCxftq/Cdhk3Uy3fbok3lq",
                "role": [],
                "type": "employee",
                "resumeUrl": null,
                "resetToken": null,
                "roles": []
            }
        }
    ];
    // await mockApi(REQUEST_DELAY_MS, response);
    // return response;
// });